"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenuItem = void 0;
var react_1 = require("react");
var menu_item_provider_1 = require("./menu-item.provider");
var useMenuItem = function () {
    var context = (0, react_1.useContext)(menu_item_provider_1.MenuContext);
    if (context) {
        return context;
    }
    throw new Error('Contexto de menu indefinido, verifique local da utilização');
};
exports.useMenuItem = useMenuItem;
